import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  dataRecycleBin: [],
  keyword: "",
  loading: false,
  sortConfig: {
    key: "updatedAt",
    direction: "DESC",
  },
  listRisk: [],
  listCategoryRiskEvent: [],
  listConnection: [],
  listUser: [],
  listRole: [],
};

export const RiskEvent = createSlice({
  name: "riskEvent",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeDataRecycleBin: (state, action) => {
      state.dataRecycleBin = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListRisk: (state, action) => {
      state.listRisk = action.payload;
    },
    ChangeListCategoryRiskEvent: (state, action) => {
      state.listCategoryRiskEvent = action.payload;
    },
    ChangeListConnection: (state, action) => {
      state.listConnection = action.payload;
    },
    ChangeListUser: (state, action) => {
      state.listUser = action.payload;
    },
    ChangeListRole: (state, action) => {
      state.listRole = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeDataRecycleBin,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListRisk,
  ChangeListCategoryRiskEvent,
  ChangeListConnection,
  ChangeListUser,
  ChangeListRole,
} = RiskEvent.actions;

export default RiskEvent.reducer;
